import { Heading } from '@chakra-ui/layout'
import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { useContractContext } from 'contexts/contract'

import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import isDisableToEditContract from '../../StepsForm/Utils/isDisableToEditContract'
import { FormContractProps } from '../FormContract/interfaces'
import { FormComplementaryValue } from './form'
import { FormComplementaryProps } from './interfaces'
import { FormComplementaryKeys } from './types'

const FormComplementary: React.FC = () => {
    const {
        register,
        watch,
        formState: { errors }
    } = useFormContext<{
        complementary: FormComplementaryProps
        contract: FormContractProps
    }>()

    const { typeContractBoolean } = useContractContext()

    const hasError = (id: FormComplementaryKeys) => {
        return errors.complementary && errors.complementary[id]
    }

    const form = useMemo(
        () => FormComplementaryValue(watch('contract.ufContrato')),
        [watch('contract.ufContrato')]
    )

    return (
        <Layout
            type="container"
            px={8}
            full
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" data-testid="form-heading">
                <Heading size="md" textAlign={{ sm: 'center' }}>
                    Dados complementares
                </Heading>
            </Layout>
            <Layout
                type="row"
                gutter={{ y: 1.5 }}
                data-testid="form-fields"
                maxH="480px"
                overflow="auto"
            >
                {form.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                err={hasError(select.id)}
                                {...register(`complementary.${select.id}`)}
                                isDisable={
                                    typeContractBoolean &&
                                    isDisableToEditContract[
                                        `complementary.${select.id}`
                                    ]
                                }
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    err={hasError(input.id)}
                                    {...register(`complementary.${input.id}`, {
                                        valueAsNumber: input.type === 'number'
                                    })}
                                    value={
                                        watch(
                                            `complementary.${input.id}`
                                        ) as string
                                    }
                                    isDisable={
                                        typeContractBoolean &&
                                        isDisableToEditContract[
                                            `complementary.${input.id}`
                                        ]
                                    }
                                />
                            )
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default FormComplementary
